export default __webpack_public_path__ + "static/media/active4.95afdfac.svg";